import { createFileRoute, Link } from "@tanstack/react-router";
import { useCallback } from "react";

import { PageHeader } from "../../components/shell/app-shell";
import { buttonClassName } from "../../components/ui/button-styles";
import { PaymentDocuments, paymentsSearchSchema, type PaymentsSearch } from "./-components/payment-documents";

export const Route = createFileRoute("/finance/receivables")({
	validateSearch: paymentsSearchSchema,
	head: () => ({ meta: [{ title: "Receivables · Finance · Ravnar" }] }),
	staticData: { crumbs: ["Finance", "Receivables"] },
	component: ReceivablesPage,
});

function ReceivablesPage() {
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const onSearch = useCallback(
		(next: PaymentsSearch) => {
			void navigate({ search: next, replace: true });
		},
		[navigate],
	);
	return (
		<>
			<PageHeader
				title="Receivables"
				description="This year's invoices you issued: what your customers still owe, and what they paid."
				actions={
					<Link to="/finance" className={buttonClassName({ size: "md" })}>
						Back to Finance
					</Link>
				}
			/>
			<PaymentDocuments side="receivables" search={search} onSearch={onSearch} />
		</>
	);
}
